import React, { useState } from 'react';
import { getFormValues, reduxForm } from 'redux-form';
import { __ } from '../../core/utils';
import styles from '../../styles/forms/plans/EditWorkingSetPlanToolbarForm.scss';
import Select from '../../components/Select';
import Tooltip from '../../components/Tooltip';
import classNames from 'classnames';
import connect from 'react-redux/es/connect/connect';
import * as _ from 'lodash';
import { subscribe } from 'react-contextual/dist/react-contextual.es';
import Localization from '../../helpers/Localization';

// ICONS
import MeetingStatusIcon from '../../assets/images/meeting-status-15x15.svg';
import ArrowDownSmallIcon from '../../assets/images/arrow-down-small-15x15.svg';
import {
  hideAlertbox,
  showAlertbox,
} from '../../redux/actions/general/alertbox';

const EditCurrentSetPlanToolbarForm = (props) => {
  const [status_switcher, set_status_switcher] = useState(false);

  const { data, values } = props;
  const { status } = values;

  const statuses = [
    {
      value: '1',
      label: __('working_set_plan.status.active'),
      color: '#5777FC',
      disabled: !_.includes(['1'], status),
    },

    {
      value: '0',
      label: __('working_set_plan.status.canceled'),
      color: '#CCCDD1',
      disabled: !_.includes(['1'], status),
    },
  ];

  const disabled = true;

  return (
    <div className={styles.wrapper}>
      <Select
        disabled={disabled}
        input={{
          value: status,

          onChange: (value) => {
            if (value === status) return;

            if (_.includes(['0'], value))
              showAlertbox({
                color: 'red',
                title: __('general.alert.are-you-sure'),
                description: `${__(
                  `working_set_plans.working-set-plan-status.first-warning`
                )}\n\n${__(
                  `working_set_plans.working-set-plan-status.second-warning`
                )}`,
                buttons: [
                  {
                    color: 'lightGray',
                    text: __('general.alert.no-close'),
                    onClick: 'close',
                  },
                  {
                    color: 'gray',
                    text: __('general.alert.yes-change-status'),
                    onClick: () => {
                      props.onSubmit({ status: value, id: data.id });

                      hideAlertbox();
                    },
                  },
                ],
              });
            else {
              // hideAlertbox();
            }
          },
          onBlur: () => set_status_switcher(false),

          onFocus: () => set_status_switcher(true),
        }}
        meta={{
          active: status_switcher,
        }}
        label={__('Status')}
        options={statuses}
        noSort
        dropdown
        top={34}
        icon={<MeetingStatusIcon className={styles.icon} />}
        wrapper={(handleOpen, activeItem) => (
          <Tooltip text={__('working-set-plans.status.tooltip.icon')}>
            <div
              className={classNames(
                styles.dropdown,
                disabled && styles.disabled
              )}
              style={{ background: activeItem.color }}
              onClick={handleOpen}
            >
              <MeetingStatusIcon className={styles.icon} />
              <div className={styles.button}>
                {activeItem.label}
                <ArrowDownSmallIcon />
              </div>
            </div>
          </Tooltip>
        )}
      />
    </div>
  );
};

const mapStateToProps = (state) => {
  return {
    user_id: state.auth.id,
    values: getFormValues('plans.edit_current_set_plan_toolbar')(state),
  };
};

export default reduxForm({
  form: 'plans.edit_current_set_plan_toolbar',
  enableReinitialize: true,
})(
  connect(
    mapStateToProps,
    null
  )(subscribe(Localization, 'localization')(EditCurrentSetPlanToolbarForm))
);
